import { SAVE_URI_STATE } from '../redux-action-types';

export default state => ({
    type: SAVE_URI_STATE,
    state
});


// WEBPACK FOOTER //
// ./src/app/action-creators/save-uri-state.js